<div class="cardContainer">
    <div class="passwordCard" *ngIf="!errorsMsgFromBack">
        <!-- <img src="assets/img/VCA-Login.png" alt="Vehicle Check App"> -->
        <div class="userReqWrapper">
            <div class="usernameContainer">
                <h4>Cambio de Contraseña</h4>
                <!-- <h3>Usuario: {{user}}</h3> -->
            </div>
            <div class="requiredContainer">
                <h4>La nueva contraseña debe contener: </h4>
                <div>
                    <span>
                        <mat-icon [ngClass]="model.password.length < 8 ? 'reqIconError' : 'reqIconOk'">
                            {{model.password.length < 8 ? 'highlight_off' : 'check_circle_outline' }} </mat-icon> Como
                                mínimo 8 caracteres
                    </span>
                    <span>
                        <mat-icon [ngClass]="model.password.length > 15 ? 'reqIconError' : 'reqIconOk'">
                            {{model.password.length > 15 ?
                            'highlight_off' : 'check_circle_outline'}}
                        </mat-icon> Como máximo 15 caracteres
                    </span>
                    <span>
                        <mat-icon [ngClass]="errorCapitalCase ? 'reqIconError' : 'reqIconOk'">{{errorCapitalCase ?
                            'highlight_off' : 'check_circle_outline'}}
                        </mat-icon> Al menos una mayúscula
                    </span>
                    <span>
                        <mat-icon [ngClass]="errorLowerCase ? 'reqIconError' : 'reqIconOk'">{{errorLowerCase ?
                            'highlight_off' : 'check_circle_outline'}}
                        </mat-icon> Al menos una minúscula
                    </span>
                    <span>
                        <mat-icon [ngClass]="errorHasNumber ? 'reqIconError' : 'reqIconOk'">{{errorHasNumber ?
                            'highlight_off' : 'check_circle_outline'}}
                        </mat-icon> Al menos un número
                    </span>
                    <span>
                        <mat-icon [ngClass]="errorPassNotMatch ? 'reqIconError' : 'reqIconOk'">{{errorPassNotMatch ?
                            'highlight_off' : 'check_circle_outline'}}
                        </mat-icon> Las contraseñas <span *ngIf="errorPassNotMatch">&nbsp;no&nbsp;</span> coinciden
                    </span>
                </div>
            </div>
        </div>
        <form autocomplete="off" #changePasswordForm='ngForm' (ngSubmit)="submit()" class="form">
            <div class="formGroup">
                <mat-form-field [hideRequiredMarker]="true" class="inputContainer">
                    <div class="passwordInput">
                        <input matInput (keydown.enter)="submit()" [type]="hide ? 'password' : 'text'"
                            placeholder="Ingrese la nueva contraseña" name="password" #password="ngModel"
                            [(ngModel)]="model.password" autocomplete="new-password" maxlength="15" required>
                        <mat-icon class="eyeIcon" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                    </div>
                    <mat-error *ngIf="!password.valid || password.pristine">Ingrese la nueva contraseña </mat-error>
                </mat-form-field>
            </div>
            <div class="formGroup">
                <mat-form-field [hideRequiredMarker]="true" class="inputContainer">
                    <div class="passwordInput">
                        <input matInput (keydown.enter)="submit()" [type]="hide ? 'password' : 'text'"
                            placeholder="Repita la nueva contraseña" name="password2" class="form-control"
                            #password2="ngModel" [(ngModel)]="model.password2" autocomplete="new-password"
                            maxlength="15" required>
                        <mat-icon class="eyeIcon" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                    </div>
                    <mat-error *ngIf="changePasswordForm.touched && changePasswordForm.invalid">
                        <mat-error *ngIf="!password2.valid || password2.pristine">Repita la nueva contraseña
                        </mat-error>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="formGroup">
                <div [ngClass]="errorRegEx || !passwordsOK ? 'errorsContainer':'errorsContainerDisable'">
                    <p *ngIf="errorRegEx">{{errorRegEx}}</p>
                    <!-- <p *ngIf="!passwordsOK && !errorRegEx">Las contraseñas no coinciden</p> -->
                </div>
                <button [disabled]='changePasswordForm.invalid || errors'
                    [ngClass]="changePasswordForm.invalid || errors ? 'submitBtnDisabled':'submitBtn'" type="submit">
                    <app-spinner *ngIf="loading" class="spinner"></app-spinner><span *ngIf="!loading">Enviar</span>
                </button>
            </div>
        </form>
    </div>
    <div class="passwordCard expired" *ngIf="errorsMsgFromBack">
        <h4>{{errorsMsgFromBack}}</h4>
    </div>
</div>